import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { RackCellMapAdapter } from './dto/rack-cell-mapping.adapter';
import { RackCellMappingController } from './rack-cell-mapping.controller';
import { RackCellMap } from './rack-cell-mapping.entity';
import { RackCellMappingService } from './rack-cell-mapping.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([RackCellMap]),
  ],
  controllers: [RackCellMappingController],
  providers: [RackCellMappingService,RackCellMapAdapter,ApplicationExceptionHandler]
})
export class RackCellMappingModule {}
